export const VIEW_DETAILS = "VIEW_DETAILS";